import mainApiClient from '../interceptor.mainApiClient';

const heatmapEndpoints = {
  generate: (alienId, data, config) =>
    mainApiClient.post(`/api/v1/aliens/${alienId}/heatmap/generate`, data, config),

  get: (alienId, config) =>
    mainApiClient.get(`/api/v1/aliens/${alienId}/heatmap`, config),

  generateTemporal: (alienId, data, config) =>
    mainApiClient.post(`/api/v1/aliens/${alienId}/heatmap/temporal/generate`, data, config),

  getTemporal: (alienId, config) =>
    mainApiClient.get(`/api/v1/aliens/${alienId}/heatmap/temporal`, config),
};

export default heatmapEndpoints;
